import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "You might not need an account", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-step__subtitle" }, " Students and teachers don't need to sign up. Enter the room code shown on a Ditto display to start sharing. ", -1)
const _hoisted_4 = ["aria-hidden"]
const _hoisted_5 = { class: "sv2-collapse__inner" }
const _hoisted_6 = { class: "sv2-warning" }
const _hoisted_7 = { class: "sv2-warning__icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-warning__title" }, "Ditto needs to be set up at your school or office first."),
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-warning__body" }, " Ditto runs on a receiver your IT team configures. Without it, there's no room code to connect to. ")
], -1)
const _hoisted_9 = { style: {"margin-top":"16px"} }
const _hoisted_10 = {
  class: "sv2-check",
  style: {"margin-top":"20px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "sv2-check__text",
  style: {"font-size":"14px","color":"rgba(26, 26, 26, 0.85)"}
}, " Yes, Ditto is already set up at my organization. ", -1)
const _hoisted_12 = ["aria-hidden"]
const _hoisted_13 = { class: "sv2-collapse__inner" }
const _hoisted_14 = { style: {"margin-top":"24px"} }
const _hoisted_15 = ["href"]
const _hoisted_16 = { style: {"margin-top":"32px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_warning = _resolveComponent("ph-warning")!
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!
  const _component_ph_arrow_square_out = _resolveComponent("ph-arrow-square-out")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(["sv2-collapse", _ctx.form.hasDitto ? 'sv2-collapse--closed' : 'sv2-collapse--open']),
      "aria-hidden": _ctx.form.hasDitto
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_ph_warning, {
              size: 20,
              weight: "fill"
            })
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "sv2-btn-secondary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('tell-admin')))
          }, [
            _createTextVNode(" Tell your admin about Ditto "),
            _createVNode(_component_ph_arrow_right, {
              size: 14,
              weight: "bold"
            })
          ])
        ])
      ])
    ], 10, _hoisted_4),
    _createElementVNode("label", _hoisted_10, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.hasDitto) = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.form.hasDitto]
      ]),
      _hoisted_11
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sv2-collapse", _ctx.form.hasDitto ? 'sv2-collapse--open' : 'sv2-collapse--closed']),
      "aria-hidden": !_ctx.form.hasDitto
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            href: _ctx.externalConnectUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "sv2-btn-primary",
            style: {"text-decoration":"none"}
          }, [
            _createTextVNode(" Connect your screen now "),
            _createVNode(_component_ph_arrow_square_out, {
              size: 16,
              weight: "bold"
            })
          ], 8, _hoisted_15)
        ])
      ])
    ], 10, _hoisted_12),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "sv2-btn-back",
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back')))
      }, [
        _createVNode(_component_ph_arrow_left, {
          size: 14,
          weight: "bold"
        }),
        _createTextVNode(" Back ")
      ])
    ])
  ]))
}